import React from "react";
import { Modal } from "react-bootstrap";
import { FaTimes, FaPlus } from "react-icons/fa";

import cn from "classnames";

import CameraScreen from './camera';

const UploadComp = ({ errors, loading, code, type, onChange, images }) => {
  const [show, setShow] = React.useState(false);

  const $removeImg = async (i) => {
    let newImg = [...images];
    newImg.splice(i, 1);
    onChange(newImg);
  };

  return (
    <>
      <div className="row align-items-center justify-content-center ">
        {images?.map((d, i) => (
          <div
            key={i}
            className="position-relative col-4"
            style={{ height: 100, width: 100, margin: 5 }}
          >
            <div
              className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
              style={{ height: 25, width: 25 }}
              onClick={() => $removeImg(i)}
            >
              <FaTimes color="#fff" />
            </div>
            <img
              src={d}
              alt=""
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                borderRadius: 5,
              }}
            />
          </div>
        ))}

        {loading ? (
          <div
            className="col-4 rounded bg-dark bg-opacity-25 d-flex flex-column align-items-center justify-content-center"
              style={{ height: 100, width: 80, margin: 5 }}
          >
            <div className="spinner-border text-blue" role="status"></div>
              <div>
                <small>uploading</small>
              </div>
            </div>
        ) : null}

        <div
          className="col-4 d-flex flex-column align-items-center justify-content-center"
            onClick={() => setShow(true)}
        >
          <div
            className={cn(
              "border-dashed rounded  d-flex flex-column align-items-center justify-content-center",
              errors ? "border-danger" : "border-primary"
            )}
            style={{ height: 100, width: 80, margin: 5 }}
          >
            <FaPlus
              size={20}
              color={errors ? "red" : "#2f83ba"}
            />
              <div>
                <small>ambil foto</small>
              </div>
          </div>

          {errors ? (
            <div
              className="text-center"
              style={{ marginBottom: 5, marginTop: 10 }}
            >
              <span style={{ color: "red" }}>
                {errors}
              </span>
            </div>
          ) : null}
        </div>
      </div>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
        fullscreen
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <CameraScreen
            files={images}
            setImg={onChange}
            numberImg={images?.length}
            onClose={() => setShow(false)}
            code={code}
            type={type}
            // setOption={(e) => setOption(e)}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default UploadComp;
